import { type MetaFunction } from 'react-router'
import { pageMeta } from '#app/utils/page-meta.ts'

export const meta: MetaFunction = (args) =>
	pageMeta(args, { title: 'Teknisk støtte' })

export default function SupportRoute() {
	return <div>Teknisk støtte</div>
}
